import { ApolloError, gql, useQuery } from '@apollo/client';

import { CountryCodes } from 'src/common/enums';
import { apolloContextWithApiV2AlcClientName } from 'src/modules/ApolloWrapper/constants';
import {
  HierarchicalLocation,
  HierarchicalLocationFragment,
  LocationParentFragment,
} from 'src/modules/Profile/graphql/hierarchicalLocations';

const suggestedLocations = gql`
  query searchHierarchicalLocations(
    $searchType: String!
    $countryCode: String!
  ) {
    searchHierarchicalLocations(
      searchType: $searchType
      countryCode: $countryCode
    ) {
      expInfo
      list {
        ...HierarchicalLocationFragment
        parents {
          ...LocationParentFragment
        }
      }
    }
  }
  ${HierarchicalLocationFragment}
  ${LocationParentFragment}
`;

interface UseSuggestedLocationsArgs {
  countryCode: string;
  searchType: 'SUGGESTION';
}

interface UseSuggestedLocationsResult {
  searchHierarchicalLocations: {
    expInfo?: string;
    list: (HierarchicalLocation | null)[];
  };
}

export const useSuggestedLocations = (
  countryCode: CountryCodes
): {
  isLoading: boolean;
  error?: ApolloError;
  expInfo?: string;
  suggestedLocations: HierarchicalLocation[];
} => {
  const result = useQuery<
    UseSuggestedLocationsResult,
    UseSuggestedLocationsArgs
  >(suggestedLocations, {
    variables: {
      countryCode: countryCode,
      searchType: 'SUGGESTION',
    },
    fetchPolicy: 'network-only',
    context: apolloContextWithApiV2AlcClientName,
  });

  return {
    isLoading: result.loading,
    error: result.error,
    expInfo: result.data?.searchHierarchicalLocations.expInfo,
    suggestedLocations: (
      result.data?.searchHierarchicalLocations.list ?? []
    ).filter((location): location is HierarchicalLocation =>
      Boolean(location?.id)
    ),
  };
};
